import React, { useMemo } from 'react';
import algoliasearch from 'algoliasearch';
import { useConstant } from '@wearejh/react-hooks/lib/useConstant';
import { SearchClient } from 'algoliasearch/dist/algoliasearch';

import { useDeps } from 'src/hooks/useDeps';

type Indexes = {
    categories: string;
    created_at_desc: string;
    bestseller_asc: string;
    pages: string;
    price_asc: string;
    price_desc: string;
    products: string;
    suggestions: string;
    wp_articles: string;
};

type AlgoliaContext = {
    client: null | SearchClient;
    indexes: Indexes;
};

export const AlgoliaContext = React.createContext<AlgoliaContext>({
    client: null,
    indexes: {
        pages: '',
        products: '',
        suggestions: '',
        categories: '',
        price_asc: '',
        price_desc: '',
        bestseller_asc: '',
        created_at_desc: '',
        wp_articles: '',
    },
});

export const AlgoliaContextProvider: React.FC = React.memo((props) => {
    const { ALGOLIA_APP_ID, ALGOLIA_API_KEY } = useDeps().env;

    const client = useConstant(() => algoliasearch(ALGOLIA_APP_ID, ALGOLIA_API_KEY));

    const env = useDeps().env;

    const indexes = useMemo(() => {
        return {
            categories: env.ALGOLIA_INDEX_PREFIX + 'default_categories',
            created_at_desc: env.ALGOLIA_INDEX_PREFIX + 'default_products_created_at_desc',
            bestseller_asc: env.ALGOLIA_INDEX_PREFIX + 'default_products_bestseller_rating_pos_asc',
            pages: env.ALGOLIA_INDEX_PREFIX + 'default_pages',
            price_asc: env.ALGOLIA_INDEX_PREFIX + 'default_products_price_default_asc',
            price_desc: env.ALGOLIA_INDEX_PREFIX + 'default_products_price_default_desc',
            products: env.ALGOLIA_INDEX_PREFIX + 'default_products',
            suggestions: env.ALGOLIA_INDEX_PREFIX + 'default_query_suggestions',
            wp_articles: env.ALGOLIA_INDEX_PREFIX_WP + 'posts_post',
        };
    }, [env.ALGOLIA_INDEX_PREFIX, env.ALGOLIA_INDEX_PREFIX_WP]);

    return (
        <AlgoliaContext.Provider
            value={{
                client,
                indexes,
            }}
        >
            {props.children}
        </AlgoliaContext.Provider>
    );
});

export default AlgoliaContextProvider;
